import React, { Component } from 'react';
import botanyHeader from "../assets/botanyHeader.png";
import '../App.css';

class HeaderAll extends Component {
  render() {
    return (
      <div className="App-headerAll">
            <img className="imgHeader" src={botanyHeader} alt="Botanica Urbana Senago!" height="480"/>
      </div>
    );
  }
}

export default HeaderAll;
